import './RightSidebar.styles.css';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchDraftRegulations } from '../../../draft-regulation/Draft.services.tsx';
import {
  fetchDeleteRequests,
  fetchPublicationRequests,
  fetchSentRequests,
} from '../../Dashboard.services.ts';
import { MdOutlineArrowOutward } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../../hooks/usePermissions.ts';
import { useMsal } from '@azure/msal-react';
import { FiPlus } from 'react-icons/fi';
import { Button } from 'antd';

export default function RightSidebar() {
  const { t } = useTranslation();
  const { canCreate } = usePermissions();
  const { accounts } = useMsal();
  const hasAccount = accounts.length > 0;
  const { data: drafts } = useQuery({
    queryKey: ['draftRegulations'],
    queryFn: fetchDraftRegulations,
    enabled: hasAccount,
    retry: false,
  });
  const { data: sentRequests } = useQuery({
    queryKey: ['sentRequests'],
    queryFn: fetchSentRequests,
    enabled: hasAccount,
    retry: false,
  });
  const { data: publicationRequests } = useQuery({
    queryKey: ['publicationRequests'],
    queryFn: fetchPublicationRequests,
    enabled: hasAccount,
    retry: false,
  });
  const { data: deleteRequests } = useQuery({
    queryKey: ['deleteRequests'],
    queryFn: fetchDeleteRequests,
    enabled: hasAccount,
    retry: false,
  });
  return (
    <>
      {canCreate && (
        <Link to="/regulation/draft" className="add-new-regulation-link">
          <Button size="large" icon={<FiPlus />} type="primary" iconPosition="start">
            {t('common.add-new-regulation')}
          </Button>
        </Link>
      )}
      <div className="section border">
        <div className="label">{t('common.my-actions')}</div>
        <div
          className="drafts-list"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div>
            <div className="user-action">{t('common.my-drafts')}</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              {drafts?.map((draft: { id: number; title: string }) => (
                <Link key={draft.id} to={`/regulation/draft/view/${draft.id}`}>
                  <div className="draft-link">
                    {draft.title} <MdOutlineArrowOutward color="var(--primary-color)" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="divider" />
          <div>
            <div className="user-action">{t('common.my-sent-requests')}</div>
            <div>
              {sentRequests?.map((draft: { draftId: number; title: string }) => (
                <Link key={draft.draftId} to={`/regulation/draft/view/${draft.draftId}`}>
                  <div className="draft-link">
                    {draft.title} <MdOutlineArrowOutward color="var(--primary-color)" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="divider" />
          <div>
            <div className="user-action">{t('common.my-received-publications')}</div>
            <div>
              {publicationRequests?.map((draft: { draftId: number; title: string }) => (
                <Link key={draft.draftId} to={`/regulation/draft/view/${draft.draftId}`}>
                  <div className="draft-link">
                    {draft.title} <MdOutlineArrowOutward color="var(--primary-color)" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="divider" />
          <div>
            <div className="user-action">{t('common.my-received-deletion')}</div>
            <div>
              {deleteRequests?.map((draft: { draftId: number; title: string }) => (
                <Link key={draft.draftId} to={`/regulation/${draft.draftId}/request-deletion`}>
                  <div className="draft-link">
                    {draft.title} <MdOutlineArrowOutward color="var(--primary-color)" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
